
import React from 'react'
import icon from './svgs/menu.svg'
import { BaseIcon } from './_base'

export const MenuIcon = ({ size, fontSize ,sx}) => {
    return (
        <BaseIcon icon = {icon} {...{fontSize,size,...sx}} />
    )
}
